import { ObservationSource } from '@jkhy/frontend-utils/observable';
import { SubscriptionHandle } from '@treasury/utils/types';
import { ConfigurationService } from '../config';
import { IRealtimeService } from './realtime.service.types';

/**
 * Provides a base class for realtime service implementation
 * that fulfills the `IRealtimeService` contract.
 */
export abstract class RealtimeService implements IRealtimeService {
    constructor(private config: ConfigurationService) {}

    /**
     * Time in milliseconds to pause between retries.
     */
    protected static RETRY_THRESHOLD = 5000;

    protected static createInitError(errMessage: string) {
        return new Error(
            `${errMessage}. A connection with the server was not established. Did you call init()?`
        );
    }

    protected readonly endpoint = `${this.config.apiRoot}/signalr`;

    protected isConnected = false;

    protected topics: string[] = [];

    protected readonly connectionSource = new ObservationSource<boolean>();

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public readonly connected$ = this.connectionSource.toObservable();

    public abstract init(useLogging: boolean): Promise<void>;

    public abstract disconnect(): Promise<void>;

    public abstract subscribe<T>(
        topic: string,
        callback: (message: T) => void
    ): Promise<SubscriptionHandle>;

    public abstract publish<T extends unknown[]>(topic: string, ...args: T): Promise<void>;
}
